export default __webpack_public_path__ + "images/d44a39f5eebffa482e28943d5a222731.svg";